module.exports = __webpack_public_path__ + "img/ico-carta.e4f90cec.svg";